// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dDate from "../Data.Date/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dCalendar$dTypes$dRestaurantLocalDay from "../Restaumatic.Calendar.Types.RestaurantLocalDay/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const eq1 = x => y => {
  if (x.tag === "Nothing") { return y.tag === "Nothing"; }
  if (x.tag === "Just") {
    if (y.tag === "Just") { return Data$dDate.eqDate.eq(x._1)(y._1); }
    return false;
  }
  return false;
};
const compare1 = /* #__PURE__ */ (() => Data$dMaybe.ordMaybe(Restaumatic$dCalendar$dTypes$dRestaurantLocalDay.ordRestaurantLocalDay).compare)();
const codeIsSymbol = {reflectSymbol: () => "code"};
const expiresOnIsSymbol = {reflectSymbol: () => "expiresOn"};
const promotionNameIsSymbol = {reflectSymbol: () => "promotionName"};
const CouponDataIsSymbol = {reflectSymbol: () => "CouponData"};
const encodeWithOptionsOther = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dGeneric$dClass.readString};
const CouponData = x => x;
const newtypeCouponData_ = {Coercible0: () => {}};
const hasFieldCouponData = dictHasField => dictHasField;
const eqCouponData = {eq: x => y => x.code === y.code && eq1(x.expiresOn)(y.expiresOn) && x.promotionName === y.promotionName};
const ordCouponData = {
  compare: x => y => {
    const v = Data$dOrd.ordString.compare(x.code)(y.code);
    if (v.tag === "LT") { return Data$dOrdering.LT; }
    if (v.tag === "GT") { return Data$dOrdering.GT; }
    const v1 = compare1(x.expiresOn)(y.expiresOn);
    if (v1.tag === "LT") { return Data$dOrdering.LT; }
    if (v1.tag === "GT") { return Data$dOrdering.GT; }
    return Data$dOrd.ordString.compare(x.promotionName)(y.promotionName);
  },
  Eq0: () => eqCouponData
};
const genericCouponData = {to: x => x, from: x => x};
const showCouponData = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ code: " + Data$dShow.showStringImpl(v.code) + ", expiresOn: " + (() => {
          if (v.expiresOn.tag === "Just") { return "(Just " + Restaumatic$dCalendar$dTypes$dRestaurantLocalDay.showRestaurantLocalDay.show(v.expiresOn._1) + ")"; }
          if (v.expiresOn.tag === "Nothing") { return "Nothing"; }
          $runtime.fail();
        })() + ", promotionName: " + Data$dShow.showStringImpl(v.promotionName) + " " + "}"
      ]
    })(CouponDataIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCouponData = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(codeIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(expiresOnIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dCalendar$dTypes$dRestaurantLocalDay.unscrambleDecodeRestaurantLocalDay))(Unscramble.decodeRecordCons(promotionNameIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeCouponData = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCouponData)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(CouponDataIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(promotionNameIsSymbol)(encodeWithOptionsOther))(expiresOnIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dCalendar$dTypes$dRestaurantLocalDay.encodeRestaurantLocalDay.encode(v2._1); }
        $runtime.fail();
      }
    }))(codeIsSymbol)(encodeWithOptionsOther);
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeCouponData = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCouponData)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(CouponDataIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(promotionNameIsSymbol)(decodeWithOptionsOther)())(expiresOnIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dCalendar$dTypes$dRestaurantLocalDay.decodeRestaurantLocalDay.decode)
  })())(codeIsSymbol)(decodeWithOptionsOther)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  CouponData,
  CouponDataIsSymbol,
  codeIsSymbol,
  compare1,
  decodeCouponData,
  decodeWithOptionsOther,
  encodeCouponData,
  encodeWithOptionsOther,
  eq1,
  eqCouponData,
  expiresOnIsSymbol,
  genericCouponData,
  hasFieldCouponData,
  newtypeCouponData_,
  ordCouponData,
  promotionNameIsSymbol,
  showCouponData,
  unscrambleDecodeCouponData
};
